// removed by extract-text-webpack-plugin
module.exports = {"link":"_3I_V4","text":"_1VVXP","tags":"_21KZd","tag":"_2NZ-I","tagsLabel":"_3cmOX"};